import { Directive, HostListener, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appSelect]',
})
export class MmSelectDirective {
  @Output() selectChanged = new EventEmitter<any>();

  @HostListener('change', ['$event.target'])
  onChange(select) {
    this.selectChanged.emit(select.value);
  }
}
